import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@shared/guards/auth.guard';
import { DeviceRedirectGuard } from '@shared/guards/device-redirect.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/news',
    pathMatch: 'full'
  },
  {
    path: 'tabs',
    canActivate: [DeviceRedirectGuard],
    loadChildren: () => import('./features/private/tabs/tabs.module').then((m) => m.TabsPageModule)
  },
  {
    path: 'desktop',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/private/desktop-layout/desktop-layout.module').then(m => m.DesktopLayoutModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./features/public/login/login.module').then((m) => m.LoginPageModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./features/public/sign-up/sign-up.module').then((m) => m.SignUpPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./features/public/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyPageModule)
  },
  {
    path: 'surveys-option',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./shared/modals/surveys-option/surveys-option.module').then( m => m.SurveysOptionPageModule)
  },
  {
    path: 'payment-flyer',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/private/payment-flyer/payment-flyer.module').then( m => m.PaymentFlyerPageModule)
  },
  {
    path: 'full-info',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/private/full-info/full-info.module').then( m => m.FullInfoPageModule)
  },
  {
    // Parametro opcional
    path: 'labor-certifications/:serviceId',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/private/tabs/services/labor-certifications/labor-certifications.module').then( m => m.LaborCertificationsPageModule)
  },
  {
    path: 'labor-benefits',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./features/private/tabs/services/labor-benefits/labor-benefits.module').then( m => m.LaborBenefitsPageModule)
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
